export default __webpack_public_path__ + "static/media/BH Icons 30 p_Breakfast.dd923b44.svg";